import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PostbackPage from './PostbackPage';
import { actions } from './PostbackPage.actions';
import {
    getCurrencies
} from './PostbackPage.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    currencies: getCurrencies
});

const PostbackPageComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            errors: state.postbacks.errors,
            loadingSave: state.postbacks.loadingSave,
            saveSuccess: state.postbacks.saveSuccess,
            newCreateId: state.postbacks.newCreateId,
            user: state.user,
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            onSave: actions.onSave,
            clearErrors: actions.clearErrors,
            onDelete: actions.onDelete
        };
    }
)(withRouter(PostbackPage));

export default PostbackPageComponent;
